<template>
  <div class="common-ct" @click="common">
    <div class="discuss">说点什么吧...</div>
    <div class="comment">
      <van-badge :content="commentCount" max="99">
        <van-image
          :src="require('@/assets/comment-icon.png')"
          width="26"
          height="24"
        ></van-image>
      </van-badge>
    </div>
    <div id="like" @click="like">
      <van-badge :content="likeCount"  max="99">
      <van-image
        :src="require('@/assets/lick-icon.png')"
        width="26"
        height="24"
      ></van-image>
      </van-badge>
    </div>
    <wx-open-launch-app class="openApp" appid="wxa496fd5f0644bb66" :extinfo="extinfo" @error="openAppErr">
        <script type="text/wxtag-template">
          <div style="position: absolute; top: 0; left: 0;width: 100%; height:100%;opacity: 0;">
          此div必须有内容才可点击，但不能在页面上展示，固采用透明度隐藏此div
          </div>
        </script>
    </wx-open-launch-app>
  </div>
</template>

<script>
export default {
  props: {
    likeCount: {
      type: Number,
      default: 0
    },
    commentCount: {
      type: Number,
      default: 0
    },
    extinfo: {
      type: String
    }
  },
  methods: {
    share () {
      this.$emit('share')
    },
    common () {
      this.$emit('common')
    },
    like () {
      this.$emit('like')
    },
    openAppErr () {
      window.open('https://a.app.qq.com/o/simple.jsp?pkgname=yslt.art.app', '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.openApp {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.common-ct {
  display: flex;
  align-items: center;
  padding: 10px 17px;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  background: #fff;
  .discuss {
    width: 240px;
    height: 36px;
    line-height: 36px;
    padding-left: 10px;
    border-radius: 35px;
    color: #999;
    margin-right: 16px;
    font-size: 14px;
    border: 1px solid #ccc;
    border-radius: 20px;
  }
  .comment {
    margin-right: 30px;
  }
  #like {
    margin-right: 20px;
  }
  .share {
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f00915;
    border-radius: 50%;
  }
}
</style>
